import React from "react";
import "./Real.css";
import Meeting from "../../assets/Meeting.png";
const Real = () => {
  return (
    <div className="Real">
      <div className="headings">
        <h2>Real People.</h2>
        <h2>Real Advice.</h2>
        <h1>
          Real <span className="yellow-tag">Solutions.</span>
        </h1>
      </div>
      <div className="para">
        We provides solutions for individuals, small businesses and corporations
        using a truly transparent holistic approach.
      </div>
      <div>
        <a href="/contact" className="btn">
          Book a Call
        </a>
      </div>
      <div className="meeting">
        <img src={Meeting} alt="" />
      </div>
    </div>
  );
};

export default Real;
